export enum MaintenanceState {
  OFF,
  SCHEDULED,
  ACTIVE
}
